/* The smallest slider that does the job: the track is a native scroll-snap
   container, so swipe, trackpad and keyboard scrolling are the browser's.
   This only keeps the dots and the scroll position in agreement, and moves the
   scroller when a dot is pressed. No autoplay, no timers, no library. */
class EmoreCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.dots = [...this.querySelectorAll('[data-carousel-dot]')];
    if (!this.track || !this.dots.length) return;

    this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
    this.addEventListener('click', this.onClick);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.sync();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    if (this.track) this.track.removeEventListener('scroll', this.onScroll);
  }

  onClick = (event) => {
    const dot = event.target.closest('[data-carousel-dot]');
    if (!dot) return;
    const slide = this.slides[Number(dot.dataset.carouselDot)];
    if (!slide) return;
    /* Reduced motion gets an instant jump rather than a long glide. */
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
  };

  onScroll = () => {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.sync());
  };

  /* The nearest slide to the scroller's leading edge is the current one. */
  sync() {
    const left = this.track.scrollLeft;
    let nearest = 0;
    let best = Infinity;
    this.slides.forEach((slide, i) => {
      const distance = Math.abs(slide.offsetLeft - this.track.offsetLeft - left);
      if (distance < best) { best = distance; nearest = i; }
    });
    this.dots.forEach((dot, i) => {
      dot.setAttribute('aria-selected', i === nearest ? 'true' : 'false');
    });
  }
}

if (!customElements.get('emore-carousel')) customElements.define('emore-carousel', EmoreCarousel);
